import $api from "@/zapi-frontend/shared/api/axios";
import { EGenerationTaskType, StatusAllResponseSchema } from "../types";

export async function getStatusAll(projectId: string, type?: EGenerationTaskType) {
  const response = await $api.get(`/chat/status-all`, { params: { projectId, type } });
  return StatusAllResponseSchema.parse(response.data).tasks;
}
